import React from 'react';
import Classes from './HowItWorks.module.css';
import { SITE } from '../../../../../data/siteConfig';

const steps = [
    { title: 'Book or Call', text: `Schedule online in under a minute or call ${SITE.phone}. We’re available 24/7.` },
    { title: 'Get a Clear Quote', text: 'We assess the job and give you honest, upfront pricing. Renovation estimates are free.' },
    { title: 'We Get It Done', text: 'Our team shows up on time, does the work right and leaves your home clean.' },
];

export default function HowItWorks() {
    return (
        <section id="how-it-works" className={`section section-dark ${Classes.section}`}>
            <img src="/assets/images/5.webp" srcSet="/assets/images/5-800.webp 800w, /assets/images/5.webp 1600w" sizes="100vw" alt="" aria-hidden="true" loading="lazy" className={Classes.bg} />
            <div className="container">
                <div className="section-head center">
                    <div className="eyebrow">How It Works</div>
                    <h2 className="section-title">Simple, Stress-Free Service</h2>
                    <p className="section-lead">Three easy steps from “something’s broken” to “it’s fixed.”</p>
                </div>

                <ol className={Classes.steps}>
                    {steps.map((s, i) => (
                        <li key={s.title} className={Classes.step}>
                            <span className={Classes.num}>{String(i + 1).padStart(2, '0')}</span>
                            <h3>{s.title}</h3>
                            <p>{s.text}</p>
                        </li>
                    ))}
                </ol>

                <div className={Classes.cta}>
                    <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-light">Book an Appointment</a>
                </div>
            </div>
        </section>
    );
}
